import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import {
	hasRouteAccess,
	extractAllowedRoutes,
} from "../../../utils/routeGuard";
import AccessDenied from "../../pages/AccessDenied";
import { useSelector, useDispatch } from "react-redux";
import { selectMenu, loadMenu } from "../../../store/menu";
const RouteGuard = ({ children }) => {
	const location = useLocation();
	const [allowedRoutes, setAllowedRoutes] = useState([]);
	const [loading, setLoading] = useState(true);
	const [hasAccess, setHasAccess] = useState(false);
	const dispatch = useDispatch();
	const menuState = useSelector(selectMenu);
	const [menuRequested, setMenuRequested] = useState(false);
	const fetchAllowedRoutes = useCallback(() => {
		// development bypass
		if (process.env.NODE_ENV === 'development') {
			setHasAccess(true);
			setLoading(false);
			return;
		}
		try {
			setLoading(true);
			const userDetails = JSON.parse(
				localStorage.getItem("userDetails") || "{}"
			);
			const roleCode = userDetails?.user?.activeRole?.roleCode || "ADMIN";
			const roleCodeLower = (roleCode || "").toString().toLowerCase();
			const isElevated = roleCodeLower.includes("headoffice") || roleCodeLower.includes("super")  || roleCodeLower.includes("admin");
			const exceptionRoutes = [
				"/emi-calculator",
				"/dashboard",
				"/profile",
				"/depositors",
			];
			if (
				exceptionRoutes.includes(location.pathname) ||
				location.pathname.startsWith("/loans") ||
				(isElevated && location.pathname.startsWith("/depositors"))
			) {
				setHasAccess(true);
				setLoading(false);
				return;
			}
			const menuData = menuState?.data || [];
			if (Array.isArray(menuData) && menuData.length > 0) {
				const routes = extractAllowedRoutes(menuData);
				setAllowedRoutes(routes);
				const access = hasRouteAccess(location.pathname, routes);
				setHasAccess(access);
				setLoading(false);
				return;
			}
			if (!menuRequested && !menuState?.loading) {
				dispatch(loadMenu(roleCode));
				setMenuRequested(true);
				return;
			}
		} catch (error) {
			console.error("Error resolving allowed routes:", error);
			setHasAccess(true);
			setLoading(false);
		}
	}, [location.pathname, menuState, dispatch, menuRequested]);
	useEffect(() => {
		fetchAllowedRoutes();
	}, [fetchAllowedRoutes, location.pathname, menuState.data]);
	useEffect(() => {
		// skip guard in development
		if (process.env.NODE_ENV === 'development') {
			setHasAccess(true);
			setLoading(false);
			return;
		}
		if (menuState?.loading) return;
		const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
		const roleCode = userDetails?.user?.activeRole?.roleCode || "ADMIN";
		const roleCodeLower = (roleCode || "").toString().toLowerCase();
		const isElevated = roleCodeLower.includes("headoffice") || roleCodeLower.includes("super")  || roleCodeLower.includes("admin");
		const exceptionRoutes = ["/emi-calculator", "/dashboard", "/profile", "/depositors", "/branches/settings"];
		if (
			exceptionRoutes.includes(location.pathname) ||
			location.pathname.startsWith("/loans") ||
			(isElevated && location.pathname.startsWith("/depositors"))
		) {
			setHasAccess(true);
			setLoading(false);
			return;
		}
		const menuData = menuState?.data || [];
		if (Array.isArray(menuData) && menuData.length > 0) {
			const routes = extractAllowedRoutes(menuData);
			setAllowedRoutes(routes);
			const access = hasRouteAccess(location.pathname, routes);
			setHasAccess(access);
			setLoading(false);
		} else if (
			menuRequested &&
			!menuState?.loading &&
			(!menuData || menuData.length === 0)
		) {
			setHasAccess(false);
			setLoading(false);
		}
	}, [menuState, location.pathname, menuRequested]);
	if (loading || menuState?.loading) {
		return (
			<div
				className="d-flex justify-content-center align-items-center"
				style={{ minHeight: "400px" }}
			>
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Loading...</span>
				</div>
			</div>
		);
	}
	if (!hasAccess) {
		return <AccessDenied />;
	}
	return children;
};
export default RouteGuard;
